import axios from "../utils/request";

export const getTickets = () => axios.get("/tickets");

export const getTicketDetail = ({ id }) => axios.get(`/tickets/${id}`);

export const getTicketDetailSeats = params =>
  axios.get(`/seats/${params.id}`, {
    params: {
      use_date: params.date,
      ticket_type: params.ticket_type
    }
  });
// 选择日期后获取场次信息
export const getTicketsType = ({ id, date }) =>
  axios.get(`/ticket_type/${id}`, { params: { use_date: date } });

export const getWeixinConfigParams = () => axios.get("/bonus_sdk");

export const getBonusId = code =>
  axios.get("/freecardo", { params: { sign_code: code } });

export const CheckWeChatPaymentResult = ({ orderid }) =>
  axios.get(`/check_pay/${orderid}`);

export const createOrder = data =>
  axios.post("/order", {
    cid: data.cid,
    info: data.info,
    tel: data.tel,
    ticket_type: data.ticket_type,
    totalNum: data.info.length,
    use_date: data.use_date,
    agent_id: 0,
    channel_id: "",
    tour_guide_id: null,
    uid: null
  });

export const payOrder = data =>
  axios.post("/pay", {
    orderid: data.orderid,
    paychannel: data.paychannel
  });

export const getOrderDetailStatus = ({ id }) => axios.get(`/get_status/${id}`);
